//#region src/helpers/video-url-parser.ts
var e = class {
	isValid = !1;
	provider = "";
	id = "";
}, t = [
	{
		provider: "youtube",
		regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?$/
	},
	{
		provider: "youtube",
		regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/shorts\/)([\w-]{11})(?:\S+)?$/
	},
	{
		provider: "vimeo",
		regex: /vimeo\..*?\/(\d+)\/([\w-]+)/i
	},
	{
		provider: "vimeo",
		regex: /vimeo\..*?\/(\d+)\?h=([\w-]+)/i
	},
	{
		provider: "vimeo",
		regex: /vimeo\..*?\/(\d+)(?:\/)?/i
	},
	{
		provider: "wistia",
		regex: /wistia\..*\/([^?]+)\??.*/i
	},
	{
		provider: "loom",
		regex: /(?:use)?loom\..*\/([^?]+)\??.*/i
	},
	{
		provider: "vidyard",
		regex: /vidyard\..*\/([^?]+)\??.*/i
	},
	{
		provider: "brightcove",
		regex: /players\.brightcove\.net\/([^/]+)\/.*videoId=([\w-]+)/i
	},
	{
		provider: "jwplayer",
		regex: /(?:cdn|content)\.(?:jwplayer|jwplatform)\.com\/players\/([\w-]+)\.html/i
	},
	{
		provider: "microsoftstream",
		regex: /web\.microsoftstream\.com\/embed\/video\/([\w-]+)/i
	},
	{
		provider: "microsoftstream",
		regex: /^(?:https?:\/\/)?([\w-]+)\.sharepoint\.com\/:v:\/(.*)/i
	},
	{
		provider: "synthesia",
		regex: /share\.synthesia\.io\/embeds\/videos\/([\w-]+)/i
	},
	{
		provider: "synthesia",
		regex: /share\.synthesia\.io\/([\w-]+)/i
	},
	{
		provider: "guidde",
		regex: /embed\.app\.guidde\.com\/playbooks\/([\w-]+)/i
	},
	{
		provider: "descript",
		regex: /share\.descript\.com\/(?:embed|view)\/([\w-]+)/i
	},
	{
		provider: "guideflow",
		regex: /app\.guideflow\.com\/(?:embed|video|player)\/([\w-]+)/i
	},
	{
		provider: "supademo-showcase",
		regex: /app\.supademo\.com\/showcase\/embed\/([\w-]+)/i
	},
	{
		provider: "supademo-showcase",
		regex: /app\.supademo\.com\/showcase\/([\w-]+)/i
	},
	{
		provider: "supademo",
		regex: /app\.supademo\.com\/embed\/([\w-]+)/i
	},
	{
		provider: "supademo",
		regex: /supademo\.com\/demo\/([\w-]+)/i
	},
	{
		provider: "arcade",
		regex: /app\.arcade\.software\/share\/([\w-]+)/i
	},
	{
		provider: "arcade",
		regex: /demo\.arcade\.software\/([\w-]+)/i
	},
	{
		provider: "supercut",
		regex: /supercut\.video\/share\/([\w-]+)\/([\w-]+)/i
	},
	{
		provider: "supercut",
		regex: /supercut\.ai\/share\/([\w-]+)\/([\w-]+)/i
	},
	{
		provider: "supercut",
		regex: /supercut\.ai\/embed\/([\w-]+)\/([\w-]+)/i
	},
	{
		provider: "clueso",
		regex: /watchclueso\.com\/embed\/([\w-]+)/i
	},
	{
		provider: "hubspot",
		regex: /player\.mux\.com\/([\w-]+)/i
	},
	{
		provider: "tella",
		regex: /(?:www\.)?tella\.tv\/video\/([\w-]+)/i
	},
	{
		provider: "storylane",
		regex: /(?:app\.)?storylane\.(?:io|com)\/(?:demo|share)\/([\w-]+)/i
	}
], n = "|";
function r(r) {
	let i = new e();
	return r && (r = r.trim(), t.some((e) => {
		let t = r.match(e.regex);
		if (t) {
			let [, ...r] = t;
			return i.provider = e.provider, i.id = r.join(n), i.isValid = !0, !0;
		} else return !1;
	})), i;
}
function i(e, t) {
	let [r, ...i] = t.split(n);
	switch (e) {
		case "youtube": return `https://www.youtube.com/embed/${r}?rel=0`;
		case "vimeo": return i.length === 0 ? `https://player.vimeo.com/video/${r}` : `https://player.vimeo.com/video/${r}?h=${i[0]}`;
		case "wistia": return `https://fast.wistia.net/embed/iframe/${r}`;
		case "loom": return `https://www.loom.com/embed/${r}`;
		case "vidyard": return `https://play.vidyard.com/${r}`;
		case "brightcove": return `https://players.brightcove.net/${r}/default_default/index.html?videoId=${i[0]}`;
		case "jwplayer": return `https://cdn.jwplayer.com/players/${r}.html`;
		case "microsoftstream": return i.length === 0 ? `https://web.microsoftstream.com/embed/video/${r}` : `https://${r}.sharepoint.com/:v:/${i[0]}`;
		case "synthesia": return `https://share.synthesia.io/embeds/videos/${r}`;
		case "guidde": return `https://embed.app.guidde.com/playbooks/${r}`;
		case "descript": return `https://share.descript.com/embed/${r}`;
		case "guideflow": return `https://app.guideflow.com/embed/${r}`;
		case "supademo": return `https://app.supademo.com/embed/${r}`;
		case "supademo-showcase": return `https://app.supademo.com/showcase/embed/${r}`;
		case "arcade": return `https://demo.arcade.software/${r}?embed`;
		case "supercut": return `https://supercut.ai/embed/${r}/${i[0]}`;
		case "clueso": return `https://watchclueso.com/embed/${r}`;
		case "hubspot": return `https://player.mux.com/${r}`;
		case "tella": return `https://www.tella.tv/video/${r}/embed`;
		case "storylane": return `https://app.storylane.io/demo/${r}`;
		default: throw Error(`Video provider ${e} not supported`);
	}
}
//#endregion
export { i as generateVideoUrl, r as parseUrl };
